
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'UnsupportedTrailerTypeOverlay',
    components: {
        ConfirmationOverlay,
    },
    props: {
        closeModalText: {
            type: String,
            required: true,
        },
        closeModalFunction: {
            type: Function,
            required: true,
        },
        goBackText: {
            type: String,
            required: true,
        },
        goBackFunction: {
            type: Function,
            required: true,
        },
    },
    computed: {},
    methods: {},
});
